import { supabase } from './supabase.js';

export function showAuthShell(onAuthed, initialMode = 'signin') {
  let mode = ['signin', 'signup', 'forgot'].includes(initialMode) ? initialMode : 'signin';

  function render() {
    const root = document.getElementById('root');
    root.innerHTML = `
      <div class="auth-shell">
        <div class="auth-card">
          <div class="auth-brand">
            <div class="logo">M</div>
            <div class="name">MANA<span class="ll">GEN</span></div>
          </div>
          <div class="auth-tabs">
            <button data-mode="signin" class="${mode==='signin'?'active':''}">Sign in</button>
            <button data-mode="signup" class="${mode==='signup'?'active':''}">Sign up</button>
            <button data-mode="forgot" class="${mode==='forgot'?'active':''}">Forgot</button>
          </div>
          <form id="authForm" autocomplete="on">
            <div class="field">
              <label>Email</label>
              <input class="input" type="email" id="auth_email" required autocomplete="email">
            </div>
            ${mode==='forgot' ? '' : `
              <div class="field">
                <label>Password</label>
                <input class="input" type="password" id="auth_password" required minlength="8" autocomplete="${mode==='signup'?'new-password':'current-password'}">
              </div>
            `}
            <button class="btn primary" type="submit" id="authSubmit" style="width:100%;justify-content:center">
              ${mode==='signin' ? 'Sign in' : mode==='signup' ? 'Create account' : 'Send reset link'}
            </button>
            <div class="auth-err" id="auth_err"></div>
            <div class="auth-msg" id="auth_msg"></div>
          </form>
          <div class="auth-foot">
            ${mode==='signup'
              ? 'Free trial: 5 generations included — no card required.'
              : mode==='forgot'
                ? 'We’ll email you a reset link.'
                : 'New here? Click <b>Sign up</b> for a free trial.'}
          </div>
          <div class="auth-foot"><a href="/" style="color:var(--ink-mute);text-decoration:none">← Back to home</a></div>
        </div>
      </div>
    `;

    root.querySelectorAll('.auth-tabs button').forEach(b =>
      b.addEventListener('click', () => { mode = b.dataset.mode; render(); })
    );

    document.getElementById('authForm').addEventListener('submit', async (e) => {
      e.preventDefault();
      const email = document.getElementById('auth_email').value.trim();
      const password = mode === 'forgot' ? null : document.getElementById('auth_password').value;
      const err = document.getElementById('auth_err');
      const msg = document.getElementById('auth_msg');
      const btn = document.getElementById('authSubmit');
      err.textContent = ''; msg.textContent = '';
      btn.disabled = true;

      try {
        if (mode === 'signin') {
          const { error } = await supabase.auth.signInWithPassword({ email, password });
          if (error) throw error;
          onAuthed();
        } else if (mode === 'signup') {
          const { error } = await supabase.auth.signUp({ email, password });
          if (error) throw error;
          msg.textContent = 'Check your email to confirm your account, then sign in.';
          mode = 'signin';
          setTimeout(render, 1800);
        } else if (mode === 'forgot') {
          const { error } = await supabase.auth.resetPasswordForEmail(email, {
            redirectTo: window.location.origin
          });
          if (error) throw error;
          msg.textContent = 'Reset link sent. Check your email.';
        }
      } catch (e) {
        err.textContent = e.message || 'Authentication failed';
      } finally {
        btn.disabled = false;
      }
    });
  }

  render();
}
